import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "./ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={11} sm={10} md={10}>
          <h3 className={classes.title}>
          Programming / Web Development
          </h3>

        </GridItem>
        
      </GridContainer>
    </div>
  );
}
